export default function QuranQuote({ verse, translation, source }) {
    return (
        <div className='relative p-8 border-l-4 shadow-sm bg-gradient-to-br from-amber-50 to-yellow-50 rounded-xl border-amber-500'>
            {/* Islamic decorative pattern */}
            <div className='absolute top-0 right-0 w-16 h-16 opacity-10'>
                <div className='text-4xl text-amber-400'>۞</div>
            </div>

            {/* Arabic verse with special styling */}
            <div className='p-4 mb-6 rounded-lg bg-white/50'>
                <p
                    className='text-2xl leading-relaxed text-right text-gray-900 font-arabic'
                    dir='rtl'
                >
                    {verse}
                </p>
            </div>

            {/* English translation */}
            <div className='p-4 mb-6 rounded-lg bg-white/70'>
                <p className='text-lg italic leading-relaxed text-right text-gray-700'>
                    "{translation}"
                </p>
            </div>

            {/* Source */}
            <div className='flex items-center justify-end gap-2 pt-4 border-t border-amber-200'>
                <div className='w-3 h-3 rounded-full bg-amber-400'></div>
                <p className='text-sm font-medium text-amber-700'>{source}</p>
            </div>
        </div>
    )
}

// Add to CSS for Arabic font:
// .font-arabic { font-family: 'Amiri', 'Scheherazade', 'Traditional Arabic', serif; }
